import { render } from "./Auth.vue?vue&type=template&id=2cc055d7"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/AM/components/Auth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cc055d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cc055d7', __exports__)) {
    api.reload('2cc055d7', __exports__)
  }
  
  module.hot.accept("./Auth.vue?vue&type=template&id=2cc055d7", () => {
    api.rerender('2cc055d7', render)
  })

}


export default __exports__